// extracted by mini-css-extract-plugin
export default {"connectOpenBanking":"LatestBankStatements_connectOpenBanking","error":"LatestBankStatements_error"};